/**
 * Therapeutic area from site/feasibility/API row payloads.
 * Prefers vTherapueticArea (ProjectMst column), then legacy therapeuticArea keys.
 */
export function pickTherapeuticArea(siteOrPayload) {
  if (!siteOrPayload) return '';
  const o = siteOrPayload;
  const v =
    o.vTherapueticArea ??
    o.VTherapueticArea ??
    o.therapeuticArea ??
    o.TherapeuticArea ??
    '';
  return typeof v === 'string' ? v : '';
}

export function pickTherapeuticAreaDisplay(siteOrPayload) {
  const v = pickTherapeuticArea(siteOrPayload);
  return v || 'N/A';
}

/**
 * Therapeutic area from ProjectMst / session project (includes legacy project description).
 */
export function pickProjectTherapeuticArea(project) {
  if (!project) return '';
  const fromTa = pickTherapeuticArea(project);
  if (fromTa) return fromTa;
  return project.projectDescription || project.ProjectDescription || '';
}
